import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';

// ================ Action types ================ //

export const FETCH_TRANSACTIONS_REQUEST = 'app/ProviderLeadsPage/FETCH_TRANSACTIONS_REQUEST';
export const FETCH_TRANSACTIONS_SUCCESS = 'app/ProviderLeadsPage/FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_ERROR = 'app/ProviderLeadsPage/FETCH_TRANSACTIONS_ERROR';

export const SET_PAGE = 'app/ProviderLeadsPage/SET_PAGE';
export const SET_ROWS_PER_PAGE = 'app/ProviderLeadsPage/SET_ROWS_PER_PAGE';

// ================ Reducer ================ //

const PAGE_SIZE = 10;

const initialState = {
  fetchTransactionsInProgress: false,
  fetchTransactionsError: null,
  
  // Data
  transactions: [],
  pagination: null,
  totalItems: 0,
  totalPages: 0,

  // UI - Pagination
  currentPage: 0,
  rowsPerPage: PAGE_SIZE,
};

export default function providerLeadsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  
  switch (type) {
    case FETCH_TRANSACTIONS_REQUEST:
      return {
        ...state,
        fetchTransactionsInProgress: true,
        fetchTransactionsError: null
      };
    case FETCH_TRANSACTIONS_SUCCESS:
      const { entities, meta } = payload;
      return {
        ...state,
        fetchTransactionsInProgress: false,
        transactions: entities || [],
        pagination: meta || null,
        totalItems: meta?.totalItems || 0,
        totalPages: meta?.totalPages || 0,
        currentPage: (meta?.page > 0 ? meta.page - 1 : 0), // meta.page is 1-indexed
      };
    case FETCH_TRANSACTIONS_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchTransactionsInProgress: false,
        fetchTransactionsError: payload
      };
    case SET_PAGE:
      return {
        ...state,
        currentPage: payload
      };
      
    case SET_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: payload,
        currentPage: 0
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchTransactionsRequest = () => ({ type: FETCH_TRANSACTIONS_REQUEST });
const fetchTransactionsSuccess = response => ({
  type: FETCH_TRANSACTIONS_SUCCESS,
  payload: response,
});
const fetchTransactionsError = e => ({
  type: FETCH_TRANSACTIONS_ERROR,
  error: true,
  payload: e,
});

export const setPage = (page) => ({
  type: SET_PAGE,
  payload: page
});
export const setRowsPerPage = (rowsPerPage) => ({
  type: SET_ROWS_PER_PAGE,
  payload: rowsPerPage
});

// ================ Thunks ================ //


export const fetchTransactions = (params = {}) => (dispatch, getState, sdk) => {
  dispatch(fetchTransactionsRequest());
  
  const { currentUser } = getState().user;
  const { currentPage, rowsPerPage } = getState().ProviderLeadsPage;
  
  if (!currentUser) {
    const error = new Error('User not authenticated');
    dispatch(fetchTransactionsError(storableError(error)));
    return Promise.reject(error);
  }

  // Query parameters for fetching transactions where current user is the provider
  const queryParams = {
    only: 'sale', // 'sale' means current user is the provider
    include: ['customer', 'provider', 'listing', 'booking'],
    'fields.transaction': [
      'id',
      'createdAt',
      'lastTransition',
      'lastTransitionedAt',
      'transitions',
      'processName',
      'processVersion',
      'protectedData.leadStart',
      'protectedData.leadEnd',
      'protectedData.bookingTransactionId',
    ],
    'fields.user': ['id', 'profile'],
    'fields.listing': ['id', 'title'],
    // 'fields.booking': ['id', 'start', 'end'],
    processNames: 'request-lead', // Use processNames (plural) not processName
    per_page: rowsPerPage,
    page: currentPage + 1,
    ...params
  };

  return sdk.transactions
    .query(queryParams)
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      const meta = response.data.meta;
      
      dispatch(fetchTransactionsSuccess({
        entities,
        meta
      }));
      return response;
    })
    .catch(e => {
      dispatch(fetchTransactionsError(storableError(e)));
      throw e;
    });
};

export const loadData = (params, search) => dispatch => {
  const queryParams = parse(search);
  return dispatch(fetchTransactions({ ...params, ...queryParams }));
};